module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-271.8fdd91c.woff2";